// src/components/Navbar.js
import { NavLink } from 'react-router-dom';
import Logo from '../assets/images/sk-logo.png';
import { getProcessedMenu } from '../utils/menu';

function Navbar() {
    const menu = getProcessedMenu();

    const cerrarSesion = () => {
        localStorage.clear(); // Limpiar el localStorage
        window.location.href = '/'; // Redirigir al inicio
    };

    // Función para generar los elementos del menú
    const renderMenu = (menuItems) => {
        return menuItems.map((item) => {
            if (item.children && item.children.length > 0) {
                return (
                    <li className="nav-item dropdown" key={item.id}>
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            id={`nav-${item.id}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {item.name}
                        </a>
                        <ul className="dropdown-menu" aria-labelledby={`nav-${item.id}`}>
                            {renderMenu(item.children)}
                        </ul>
                    </li>
                );
            } else {
                return (
                    <li key={item.id}>
                        <NavLink to={item.path} className="dropdown-item">
                            {item.name}
                        </NavLink>
                    </li>
                );
            }
        });
    };

    return (
        <nav className="navbar navbar-expand-sm shadow-sm bg-white" aria-label="Third navbar example">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src={Logo} alt="SK Logo" className="nav-logo" />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse bg-white" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-sm-0">
                        {renderMenu(menu)}
                    </ul>
                    {/* Botones de Ayuda y Cerrar Sesión */}
                    <ul className="navbar-nav mb-2 mb-sm-0 align-items-center">
                        <li className="nav-item me-2">
                            <NavLink to="/ayuda" className="nav-link d-flex align-items-center">
                                <i className="bi bi-question-circle fs-5 me-1"></i>
                                Ayuda
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link btn btn-link d-flex align-items-center" onClick={cerrarSesion}>
                                <i className="bi bi-box-arrow-right fs-5 me-1"></i>
                                Cerrar Sesión
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
